import { IconButton, Typography } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";
import { HeadingNav } from "../navigation/HeadingNav";
import { useOrganisationStyles } from "./useOrganisationStyles";
import { useRouteMatch } from "react-router-dom";
import { useIsEmbedded } from "../../../hooks/useIsEmbedded";
import { MaxWidthPage } from "../page/MaxWidthPageWithHeading";
import { EmbeddedPage } from "../page/EmbeddedPage";
import { useHeadingStyles } from "../page/Heading";
import { OrganisationContactChip } from "./OrganisationContactChip";
import { uppercaseFirst } from "utils/utils";
import { OrganisationAvatar } from "../avatar/OrganisationAvatar";

export const OrganisationRootContent = ({ organisation, children }) => {
    const classes = useOrganisationStyles();
    const headingClasses = useHeadingStyles();
    const hasEvents = organisation.events?.length > 0;
    const hideRankingsTab =
        !organisation.series?.length ||
        organisation.series?.every(
            (series) => !series.rankingsDivisions?.length,
        );
    const isFederation = organisation.federatedOrganisations?.length > 0;
    const isEmbedded = useIsEmbedded();
    const isSignOn = useRouteMatch(
        "/:shortName/(sign-on.*|series/.*/sign-on.*)",
    );
    const hasOpenSeriesMemberships =
        organisation.series?.filter((series) => series.signOnStatus === "open")
            .length > 0;

    if (isEmbedded) return <EmbeddedPage>{children}</EmbeddedPage>;
    if (isSignOn) return children;

    return (
        <MaxWidthPage>
            <Typography variant="h5" component="h1" className={classes.heading}>
                <OrganisationAvatar
                    alt={organisation.name}
                    src={organisation.logo}
                    size="xxl"
                />
                <section>
                    <div className={classes.name}>{organisation.name}</div>
                    <section>
                        {organisation.instagram && (
                            <IconButton
                                size="small"
                                className={classes.media}
                                color="inherit"
                                component="a"
                                href={organisation.instagram}
                                target="_blank"
                            >
                                <Instagram />
                            </IconButton>
                        )}
                        {organisation.facebook && (
                            <IconButton
                                size="small"
                                className={classes.media}
                                color="inherit"
                                component="a"
                                href={organisation.facebook}
                                target="_blank"
                            >
                                <Facebook />
                            </IconButton>
                        )}
                    </section>
                </section>
            </Typography>

            <OrganisationContactChip organisation={organisation} />

            <HeadingNav
                className={headingClasses.headingNav}
                links={[
                    { label: "Home", to: `/${organisation.shortName}` },
                    hasEvents && {
                        label: "Events",
                        to: `/${organisation.shortName}/events`,
                    },
                    hasOpenSeriesMemberships && {
                        label: "Memberships",
                        to: `/${organisation.shortName}/memberships`,
                    },
                    !hideRankingsTab && {
                        label: "Rankings",
                        to: `/${organisation.shortName}/rankings`,
                    },
                    isFederation && {
                        label: `${uppercaseFirst(organisation.federatedOrganisationTerm || "organisation")}s`,
                        to: `/${organisation.shortName}/federated-organisations`,
                    },
                ]}
            />
            {children}
        </MaxWidthPage>
    );
};
